"use client"

import { createIcon } from "@chakra-ui/react"

export const ChatBubbleIcon = createIcon({
  displayName: "ChatBubbleIcon",
  viewBox: "0 0 512 512",
  defaultProps: {},
  path: (
    <>
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="32"
        stroke="currentColor"
        d="M87.48 380c1.2-4.38-1.43-10.47-3.94-14.86a42.63 42.63 0 0 0-2.54-3.8 199.81 199.81 0 0 1-33-110C47.64 139.09 140.72 48 255.82 48 356.2 48 440 117.54 459.57 209.85a199 199 0 0 1 4.43 41.64c0 112.41-89.49 204.93-204.59 204.93-18.31 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.14 31.14 0 0 0-11.13-2.07 30.7 30.7 0 0 0-12.08 2.43L81.5 462.78a15.92 15.92 0 0 1-4.66 1.22 9.61 9.61 0 0 1-9.58-9.74 15.85 15.85 0 0 1 .6-3.29z"
      />
      <circle cx="160" cy="256" r="32" fill="currentColor" />
      <circle cx="256" cy="256" r="32" fill="currentColor" />
      <circle cx="352" cy="256" r="32" fill="currentColor" />
    </>
  ),
})

export const CheckmarkCircleIcon = createIcon({
  displayName: "CheckmarkCircleIcon",
  viewBox: "0 0 512 512",
  defaultProps: {},
  path: (
    <>
      <path d="M170.718 216.482L141.6 245.6l93.6 93.6 208-208-29.118-29.118L235.2 279.918l-64.482-63.436zM422.4 256c0 91.518-74.883 166.4-166.4 166.4S89.6 347.518 89.6 256 164.482 89.6 256 89.6c15.6 0 31.2 2.082 45.764 6.241L334 63.6C310.082 53.2 284.082 48 256 48 141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208h-41.6z" />
    </>
  ),
})

export const DotFillIcon = createIcon({
  displayName: "DotFillIcon",
  viewBox: "0 0 24 24",
  defaultProps: {},
  path: (
    <>
      <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
    </>
  ),
})

export const EllipsisHorizontalIcon = createIcon({
  displayName: "EllipsisHorizontalIcon",
  viewBox: "0 0 20 20",
  defaultProps: {
    fill: "currentColor",
    "aria-hidden": "true",
  },
  path: (
    <>
      <path d="M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
    </>
  ),
})

export const EllipsisVIcon = createIcon({
  displayName: "EllipsisVIcon",
  viewBox: "0 0 192 512",
  defaultProps: {},
  path: (
    <>
      <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z" />
    </>
  ),
})

export const PersonOutlineIcon = createIcon({
  displayName: "PersonOutlineIcon",
  viewBox: "0 0 24 24",
  defaultProps: {},
  path: (
    <>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
        fill="currentColor"
      />
    </>
  ),
})
